/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum AreaType {
    Frame = 0,
    Filler = 1,
    Empty = 2,
}
